import React from 'react';
import { graphql } from 'gatsby'
import StyleSorter from '../components/StyleSorter';
// import CTABlock from '../components/CTABlock'
import ContactForm from '../components/ContactForm'
import Seo from '../components/SEO';


function PageTemplate({ data })
{

  return (
    <>
      <Seo
        title={data.datoCmsPage.seoField?.title}
        description={data.datoCmsPage.seoField?.description}
        noIndex={data.datoCmsPage.noIndex}
        noFollow={data.datoCmsPage.noFollow}
      />
      {data.datoCmsPage.modContent.map(block => <StyleSorter key={block.id} block={block} />)}
      {/* {data.datoCmsPage.name.substring(0, 4) === "Case" && <CTABlock {...data.datoCmsCta} />}
      {data.datoCmsPage.name === "Voor werkgevers" && <CTABlock {...data.datoCmsCta} alt />} */}
      {data.datoCmsPage.name === "contact" && <ContactForm />}
    </>
  );
}

export default PageTemplate;

export const query = graphql`
  query PageQuery($name: String) {
    datoCmsPage(name: {eq: $name}) {
      name
      noIndex
      noFollow
      seoField {
        title
        description
      }
      modContent {
        id
        name
        style {
          name
        }
        content {
          ... on DatoCmsContent {
            id
            text {
              value
              blocks {
                ... on DatoCmsBlockHeroItem {
                  __typename
                  id: originalId
                  headline
                  text {
                    value
                  }
                  ctaText
                  url {
                    slug
                  }
                }
                ... on DatoCmsBlockCijfer {
                  __typename
                  id: originalId
                  description
                  aantal
                  image {
                    url
                  }
                }
                ... on DatoCmsBlockHeadline {
                  __typename
                  id: originalId
                  headline
                  style {
                    name
                  }
                }
                ... on DatoCmsBlockCase {
                  __typename
                  id: originalId
                  headline
                  description: text
                  urlText
                  ctaUrl {
                    slug
                  }
                  image {
                    gatsbyImageData(height: 250, placeholder: BLURRED)
                  }
                }
                ... on DatoCmsBlockImage {
                  __typename
                  id: originalId
                  image {
                    gatsbyImageData(placeholder: BLURRED, width: 900)
                  }
                }
                ... on DatoCmsBlockDoing {
                  __typename
                  id: originalId
                  title
                  gif {
                    url
                  }
                  image {
                    gatsbyImageData(placeholder: BLURRED)
                  }
                }
                ... on DatoCmsBlockCustomer {
                  __typename
                  id: originalId
                  name
                  nameCustomer
                  functie
                  image {
                    gatsbyImageData(width: 200, placeholder: BLURRED)
                  }
                  customerText
                }
                ... on DatoCmsBlockBlue {
                  __typename
                  id: originalId
                  title
                  doings
                  buttonText
                  buttonUrl {
                    slug
                  }
                  image {
                    gatsbyImageData(height: 192, placeholder: DOMINANT_COLOR)
                  }
                }
              }
            }
          }
          ... on DatoCmsCta {
            headline
            subheadline
            url {
              slug
            }
            buttonText
            textBelowButton
              }
            }
          }
    #   datoCmsCta {
    #     headline
    #     subheadline
    #     url {
    #       slug
    #     }
    #     buttonText
    #     textBelowButton
    # }
    }
  }
`